import React, { Component } from "react";
import { ChevronDown, ChevronLeft } from "react-feather";
import { connect } from "react-redux";
import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
// import save from "views/profile/img/save.svg";
import {
  getDESIGNATIONAction,
  getCURRENCYAction,
  getDEPARTMENTMASTERAction,
  getEMPTYPEMASTERAction,
  getINDUSTRYMASTERAction,
  getCOUNTRYMASTERAction,
} from "store/masters";
import { getEmployeeAction, setEmploymentAction } from "store/userWalkthrough";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import kyc from "views/profile/img/kyc/kyc.png";
class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddExperience: true,
      EmployerRID: "0",
      CurrentEmpStatus: "",
      Organization: "",
      FromDate: null,
      ToDate: null,
      DesignationID: null,
      Designation: null,
      Department: "",
      CTCPerMonth: "",
      Currency: "",
      EmployeeCode: "",
      IndustryID: "",
      EmploymentTypeID: "",
      CountryID: "",
      OfficeAddress: "",
      ReasonforLeaving: "",
      MonthOfExp: 0,
      YearOfExp: 0,
      ExpectedCTC: 0,
      ExpectedCurrency: 0,
      CurrentCTC: 0,
      CurrentCurrency: 0,
      NoOfCompany: 0,
      CompaniesRoleInfo: [],
      inputList: [
        {
          DesignationID: null,
          Designation: null,
          FromDate: null,
          ToDate: null,
        },
      ],
    };
  }
  // componentDidUpdate = async (prevProps,previewState) => {
  //   if (this.props.EMPLOYEMENTDETAILS.params.PID !== prevProps.match.params.PID) {

  //   }
  // }
  // new logic
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    debugger;
    let list = JSON.parse(JSON.stringify([...this.state.inputList]));

    list[index][name] = value;
    this.setState({ inputList: list });
  };
  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });
    // setInputList(list);
  };
  handleAddClick = () => {
    this.setState({
      inputList: [
        ...this.state.inputList,
        { DesignationID: "", Designation: "", FromDate: null, ToDate: null },
      ],
    });
  };
  renderformHTML() {
    return this.state.inputList.map((x, i) => (
      <>
        <div className="lg:flex md:flex items-center mb-1" key={i}>
          <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4">
            <label for="">Role {i + 1}</label>
            <div class="relative w-full right-0 rail-select">
              <div class="select-side">
                {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                <ChevronDown className="text053C6D" />
              </div>
              <select
                required
                className="select-dropdown-c fsize15"
                name="DesignationID"
                value={x.DesignationID || ""}
                onChange={(e) => this.handleInputChange(e, i)}
              >
                <option value="" disabled>
                  Select
                </option>
                {this.props.DESIGNATION
                  ? this.props.DESIGNATION.Data
                    ? this.props.DESIGNATION.Data.map((x) => {
                        return <option value={x.Value}>{x.Title}</option>;
                      })
                    : ""
                  : ""}
              </select>
            </div>
          </div>

          <div class="pt-4  lg:w-1/2 md:w-1/2  w-full lg:pl-4 md:pl-4">
            <div className="flex items-center ">
              <div className=" form-group modal-form-cs w-1/2 pr-3">
                <label for="">Duration From</label>
                <input
                  required
                  type="date"
                  name="FromDate"
                  className="select-dropdown-c fsize15"
                  value={x.FromDate}
                  onChange={(e) => this.handleInputChange(e, i)}
                ></input>
              </div>

              <div className=" form-group modal-form-cs w-1/2 pl-3">
                <label for="">To</label>
                <input
                  required
                  type="date"
                  name="ToDate"
                  className="select-dropdown-c fsize15"
                  value={x.ToDate}
                  onChange={(e) => this.handleInputChange(e, i)}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </>
    ));
  }
  //end

  async addCompRepArray() {
    let arr = {
      DesignationID: this.state.DesignationID,
      " Designation ": this.state.Designation,
      FromDate: this.convert2(this.state.FromDate),
      ToDate: this.convert2(this.state.ToDate),
    };
    let arr1 = arr1.push(arr);
    this.setState({ CompaniesRoleInfo: arr1 });
  }
  async saveEmploymentDetails(e) {
    e.preventDefault();
    var c_array = [
      {
        EmployerRID: this.state.EmployerRID,
        EmployeeRID: this.state.EmployerRID,
        CurrentEmpStatus: this.state.CurrentEmpStatus,
        Organization: this.state.Organization,
        // FromDate: this.convert2(this.state.FromDate),
        // ToDate: this.convert2(this.state.ToDate),
        // DesignationID: this.state.DesignationID,
        // Designation: this.state.Designation,
        Department: this.state.Department,
        CTCPerMonth: this.state.CTCPerMonth,
        Currency: this.state.Currency,
        EmployeeCode: this.state.EmployeeCode,
        IndustryID: this.state.IndustryID,
        EmploymentTypeID: this.EmploymentTypeID,
        CountryID: this.state.CountryID,
        OfficeAddress: this.state.OfficeAddress,
        ReasonforLeaving: this.state.ReasonforLeaving,
        CompaniesRoleInfo: this.state.inputList,
      },
    ];
    var obj = {
      CandidateNo: this.props.Auth.HCID,
      MonthOfExp: this.state.MonthOfExp,
      YearOfExp: this.state.YearOfExp,  
      ExpectedCTC: this.state.ExpectedCTC,
      "ExpectedCurrency ": this.state.ExpectedCurrency,
      CurrentCTC: this.state.CurrentCTC,
      CurrentCurrency: this.state.CurrentCurrency,
      NoOfCompany: this.state.NoOfCompany,
      CompaniesInfo: c_array,
    };
    let response = await this.props.setEmploymentAction(obj);

    if (response.ResponseCode == 100) {
      this.setState({ isAddExperience: true });
      this.props.getEmployeeAction(this.props.Auth.HCID);
    } else {
      alert(response.ResponseMessage);
    }
  }
  convert2(str) {
    var months = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec",
    };

    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    for (var key in months) {
      if (mnth == key) {
        mnth = months[key];
      }
    }
    return [day, mnth, date.getFullYear()].join("-");
  }
  async emptyState() {
    this.setState({
      EmployerRID: "0",
      CurrentEmpStatus: "",
      Organization: "",
      FromDate: "",
      ToDate: "",
      DesignationID: "",
      Designation: "",
      Department: "",
      CTCPerMonth: "",
      Currency: "",
      EmployeeCode: "",
      IndustryID: "",
      EmploymentTypeID: "",
      CountryID: "",
      OfficeAddress: "",
      ReasonforLeaving: "",
    });
  }
  async editEmployment(x) {
    this.setState({
      isAddExperience: false,
      EmployerRID: x.EmployeeRID,
      CurrentEmpStatus: x.CurrentEmpStatus,
      Organization: x.Organization,
      FromDate: x.FromDate ? new Date(x.FromDate) : "",
      ToDate: x.ToDate ? new Date(x.ToDate) : "",
      DesignationID: x.DesignationID,
      Designation: x.Designation,
      Department: x.Department,
      CTCPerMonth: x.CTCPerMonth,
      Currency: x.Currency,
      EmployeeCode: x.EmployeeCode,
      IndustryID: x.IndustryID,
      EmploymentTypeID: x.EmploymentTypeID,
      CountryID: x.CountryID,
      OfficeAddress: x.EmploymetAddress,
      ReasonforLeaving: x.ReasonforLeaving,
      inputList: x.CompaniesRoleInfoDetail,
    });
  }
  async componentDidMount() {
    try {
      await this.props.getDESIGNATIONAction();
      await this.props.getCURRENCYAction();
      await this.props.getDEPARTMENTMASTERAction();
      await this.props.getEMPTYPEMASTERAction();
      await this.props.getINDUSTRYMASTERAction();
      await this.props.getCOUNTRYMASTERAction();

      this.setState({
        MonthOfExp: this.props.EMPLOYEMENTDETAILS.Data.MonthOfExp,
        YearOfExp: this.props.EMPLOYEMENTDETAILS.Data.YearOfExp,
        ExpectedCTC: Math.round(this.props.EMPLOYEMENTDETAILS.Data.ExpectedCTC),
        ExpectedCurrency: this.props.EMPLOYEMENTDETAILS.Data.ExpectedCurrency,
        CurrentCTC: Math.round(this.props.EMPLOYEMENTDETAILS.Data.CurrentCTC),
        CurrentCurrency: this.props.EMPLOYEMENTDETAILS.Data.CurrentCurrency,
        NoOfCompany: this.props.EMPLOYEMENTDETAILS.Data.NoOfCompany,
      });
    } catch (error) {}
  }
  async saveCTCEXP() {
    var obj = {
      CandidateNo: this.props.Auth.HCID,
      MonthOfExp: this.state.MonthOfExp,
      YearOfExp: this.state.YearOfExp,
      ExpectedCTC: this.state.ExpectedCTC,
      ExpectedCurrency: this.state.ExpectedCurrency,
      CurrentCTC: this.state.CurrentCTC,
      CurrentCurrency: this.state.CurrentCurrency,
      NoOfCompany: this.state.NoOfCompany,
      CompaniesInfo: [],
    };
    let response = await this.props.setEmploymentAction(obj);

    if (response.ResponseCode == 100) {
      alert(response.ResponseMessage);
      this.setState({ isAddExperience: true });
      this.props.getEmployeeAction(this.props.Auth.HCID);
    } else {
      alert(response.ResponseMessage);
    }
  }
  render() {
    // console.log("props",this.props.EMPLOYEMENTDETAILS.Data.tEmploymentDetails)
    return (
      <card
        className={`rounded-12px bg-white block  mt-2 w-full   ${
          this.props.hasexperience1
            ? "drop-shadow20 lg:p-8 md:p-8 p-5"
            : "shadow-none"
        }`}
      >
        {/* <div className="lg:px-12 md:px-12 pb-6"> */}
        <div
          className={`   ${
            this.props.hasexperience2 ? "lg:px-12 md:px-12 pb-6" : ""
          }`}
        >
          {this.state.isAddExperience && (
            <div>
              <div className="text-right mb-8">
                {/* <div className="flex sm-col-reverse justify-between mb-8"> */}
                <card className="rounded-md lg:mt-0 md:mt-0 mt-6   drop-shadow20  sm-w-full width-exp  bg-white block lg:pl-6 md:pl-6 lg:pr-4 pl-4 pr-4 md:pr-4 py-4 ">
                  <div className="lg:flex md:flex justify-between relative exp-gap">
                    <div>
                      <p className="fsize16  text-left text-black">
                        Total work experience :{" "}
                        {/* <span className="font-semibold text-black">
                          3 yrs 2 months
                        </span> */}
                        <div className="flex items-center lg:ml-2 md:ml-2 lg:mt-0 md:mt-0 mt-3">
                          <input
                            maxLength={2}
                            onChange={(e) =>
                              this.setState({ YearOfExp: e.target.value })
                            }
                            value={
                              this.state.YearOfExp == 0
                                ? ""
                                : this.state.YearOfExp
                            }
                            type="text"
                            placeholder="   Year"
                            className="mr-1 inputborder-c"
                          ></input>
                          <input
                            maxLength={2}
                            onChange={(e) =>
                              this.setState({ MonthOfExp: e.target.value })
                            }
                            value={
                              this.state.MonthOfExp == 0
                                ? ""
                                : this.state.MonthOfExp
                            }
                            type="text"
                            placeholder="   Months"
                            className="ml-1 inputborder-c"
                          ></input>
                        </div>
                      </p>
                    </div>

                    <div className="lg:pt-0 md:pt-0  pt-6">
                      <p className="fsize15 text-black text-left">
                        Current CTC :{" "}
                        {/* <span className="font-semibold text-black">1.2L</span> */}
                        <input
                          maxLength={10}
                          onChange={(e) =>
                            this.setState({ CurrentCTC: e.target.value })
                          }
                          value={
                            this.state.CurrentCTC == 0
                              ? ""
                              : this.state.CurrentCTC
                          }
                          type="text"
                          placeholder="   Current CTC"
                          className=" inputborder-c lg:mt-0 md:mt-0 mt-3"
                        ></input>
                      </p>
                    </div>

                    <div className="lg:pt-0 md:pt-0   pt-6">
                      <p className="fsize16 text-black text-left">
                        Expected CTC :{" "}
                        {/* <span className="font-semibold text-black">2.4L</span> */}
                        <input
                          maxLength={10}
                          onChange={(e) =>
                            this.setState({ ExpectedCTC: e.target.value })
                          }
                          value={
                            this.state.ExpectedCTC == 0
                              ? ""
                              : this.state.ExpectedCTC
                          }
                          type="text"
                          placeholder="   Expected CTC"
                          className=" inputborder-c lg:mt-0 md:mt-0 mt-3"
                        ></input>
                      </p>
                    </div>

                    <div class="lg:mt-0 md:mt-0 mt-6 cust-10per flex lg:items-end md:items-end justify-center ">
                      <div className="exp-save-btn sm-w-100px ">
                        <button alt="edit" class="mt-0.5" onClick={() => this.saveCTCEXP()}>
                          save
                        </button>
                      </div>
                    </div>
                  </div>
                </card>
                <button
                  className="outline-btn fsize16 sm-fsize14  sm-h-45px font-semibold w-200px  mt-6  uppercase"
                  onClick={() =>
                    this.setState({
                      isAddExperience: !this.state.isAddExperience,
                    })
                  }
                >
                  ADD Experience
                </button>
              </div>

              <div className="lg:grid md:grid lg:grid-cols-3 md:grid-cols-3 gap-8 mt-12">
                {/* ICICI Bank */}

                {this.props.EMPLOYEMENTDETAILS
                  ? this.props.EMPLOYEMENTDETAILS.Data.tEmploymentDetails.map(
                      (x) => {
                        return (
                          <card className="rounded-sm borderblue-t-5px  drop-shadow20 bg-white h-500px block px-6 py-4  lg:mb-0 md:mb-0 mb-6">
                            <div className="flex justify-between 	">
                              <p className="text-black font-bold fsize16">
                                {x.Organization}
                              </p>
                              <div className="flex items-center">
                                <img
                                  src={edit}
                                  alt="edit"
                                  onClick={(e) => this.editEmployment(x)}
                                  className="text053C6D w-5 h-5 "
                                />
                              </div>
                            </div>
                            <p className="border707070-t opacity-20 my-4 	"></p>
                            <div className="overflow-auto-grey h300px">
                              {/* <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Duration
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>
                              <div className="w-5/12">
                                <p className="text4B4B4B fsize14 opacity-90 ">
                                  {x.FromDate + "-" + x.ToDate}
                                </p>
                                <p className="text4B4B4B fsize14 opacity-90 ">
                                 
                                </p>
                              </div>
                            </div>{" "} */}
                              <div className="flex justify-between mb-4">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  Industry
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.Industry}
                                </p>
                              </div>
                              <div className="flex justify-between mb-4">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  Employee Code
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.EmployeeCode}
                                </p>
                              </div>
                              {/* <div className="status-line mb-4 relative">
                              <div className="mb-4">
                                <div className="flex justify-between mb-">
                                  <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                    Role
                                  </p>
                                  <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                    :
                                  </p>

                                  <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                    {x.Designation}
                                  </p>
                                </div>
                              </div>
                            </div> */}

                              <div className="status-line mb-4 relative">
                                {/* {x ? (
                                  x.CompaniesRoleInfoDetail.length > 1 ? (
                                    <p>hoiii</p>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )} */}

                                {x
                                  ? x.CompaniesRoleInfoDetail.map((y, i) => {
                                      return (
                                        <div className="mb-4 ">
                                          <div className="absolute role-h">
                                            <p className="dot-status  bg053C6D"></p>

                                            <p className="dot-statusline"></p>

                                            <p className="dot-status  bg053C6D"></p>
                                          </div>{" "}
                                          <div className="flex justify-between mb-1">
                                            <p className="text4B4B4B fsize14 opacity-70 w-5/12 pl-4">
                                              Role {i + 1}
                                            </p>
                                            <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                              :
                                            </p>

                                            <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                              {y.Designation}
                                            </p>
                                          </div>
                                          <div className="flex justify-between mb-3 ">
                                            <p className="text4B4B4B fsize14 opacity-70 w-5/12 pl-4">
                                              Time Period
                                            </p>
                                            <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                              :
                                            </p>

                                            <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                              {y.FromDate}-{y.ToDate}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    })
                                  : ""}
                              </div>
                              <div className="flex justify-between mb-3 pt-4">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  Country
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.Country}
                                </p>
                              </div>

                              <div className="flex justify-between mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  Employment Address
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.EmploymetAddress}
                                </p>
                              </div>
                              <div className="flex justify-between mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  CTC
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.CTCPerMonth}
                                </p>
                              </div>
                              <div className="flex justify-between mb-3">
                                <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                  ReasonforLeaving
                                </p>
                                <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                  :
                                </p>

                                <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                  {x.ReasonforLeaving}
                                </p>
                              </div>
                            </div>
                          </card>
                        );
                      }
                    )
                  : ""}
              </div>
              {!this.props.EMPLOYEMENTDETAILS ? (
                <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 lg:mt-4 md:mt-4  sm-shadow-none">
                  <div className="lg:px-12 md:px-12 pb-4">
                    <img
                      src={kyc}
                      alt="kyccomplete"
                      className="w-full h-240px mob-ekyc sm-h190px"
                    />

                    <div className="flex justify-center mt-8">
                      <p className="text-black line-h30 fsize18 sm-fsize14   lg:w-3/4 md:w-3/4 text-center">
                        No employment details are present for your profile,
                        please add employment details.
                      </p>
                    </div>

                    <div class="w-full  flex justify-center  mt-10">
                      {/* <button
                        className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px"
                        onClick={() =>
                          this.setState({
                            isAddExperience: !this.state.isAddExperience,
                          })
                        }
                      >
                        ADD EMPLOYEMENT DETAILS
                      </button> */}
                    </div>
                  </div>
                </card>
              ) : (
                ""
              )}
            </div>
          )}

          {!this.state.isAddExperience && (
            <form onSubmit={(e) => this.saveEmploymentDetails(e)}>
              <div className="relative">
                {/* <div className="transform-tab cursor-pointer lg:mb-0 mb-4 ">
                <div className="flex lg:justify-evenly md:justify-evenly lg:px-0 px-3 justify-between items-center bgFDF1E7 rounded-8px h-41px w-200px sm-w-full">
                  <p className="text-black opacity-65 fsize14 font-semibold ">
                    Open Resume Tab
                  </p>
                  <ChevronDown className="text053C6D" />
                </div>
              </div> */}
                <div>
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() =>
                      this.setState({
                        isAddExperience: !this.state.isAddExperience,
                        ReasonforLeaving: "",
                        OfficeAddress: "",
                        EmploymentTypeID: "",
                        EmployeeCode: "",
                        CurrencyID: "",
                        CTCPerMonth: "",
                        IndustryID: "",
                        Organization: "",
                      })
                    }
                  >
                    <ChevronLeft className="text053C6D" />
                    <p className="text-black fsize16 pl-2 font-semibold">
                      Add Experience
                    </p>
                  </div>

                  <div className="mt-2 lg:w-11/12 md:w-11/12 w-full lg:pl-6 md:pl-6">
                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                        <label for="">Company Name</label>
                        <input
                          required
                          maxLength={50}
                          type="text"
                          placeholder=""
                          className=" fsize15"
                          value={this.state.Organization}
                          onChange={(e) =>
                            this.setState({ Organization: e.target.value })
                          }
                        />
                      </div>
                      {/* <div class="pt-4  lg:w-1/2 md:w-1/2  lg:pl-4 md:pl-4">
                      <div className="flex items-center">
                        <div className=" form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full  pr-3 ">
                          <label for="">Duration From</label>
                          <DatePicker
                       
                            selected={this.state.FromDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) =>
                              this.setState({ FromDate: date })
                            }
                          />
                        </div>

                        <div className=" form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full pl-3 ">
                          <label for="">To</label>
                          <DatePicker
                      
                            selected={this.state.ToDate}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => this.setState({ ToDate: date })}
                          />
                        </div>
                      </div>
                    </div> */}
                    </div>
                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group pt-4 modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-3">
                        <label for="">Industry</label>
                        <div class="relative w-full right-0 rail-select">
                          <div class="select-side">
                            {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                            <ChevronDown className="text053C6D" />
                          </div>
                          <select
                            required
                            className="select-dropdown-c fsize15"
                            value={this.state.IndustryID}
                            onChange={(e) =>
                              this.setState({ IndustryID: e.target.value })
                            }
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {this.props.INDUSTRY
                              ? this.props.INDUSTRY.Data
                                ? this.props.INDUSTRY.Data.map((x) => {
                                    return (
                                      <option value={x.Value}>{x.Title}</option>
                                    );
                                  })
                                : ""
                              : ""}
                          </select>
                        </div>
                      </div>
                      {/* <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                      <label for="">Position held/Designation</label>
                      <select
                 
                        className="select-dropdown-c fsize15"
                        value={this.state.DesignationID}
                        onChange={(e) =>
                          this.setState({ DesignationID: e.target.value })
                        }
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        {this.props.DESIGNATION
                          ? this.props.DESIGNATION.Data
                            ? this.props.DESIGNATION.Data.map((x) => {
                                return (
                                  <option value={x.Value}>{x.Title}</option>
                                );
                              })
                            : ""
                          : ""}
                      </select>
                    </div> */}
                    </div>

                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group pt-4 modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-3">
                        <label for="">CTC</label>
                        <input
                          required
                          maxlength="10"
                          type="number"
                          placeholder=""
                          className=" fsize15"
                          value={this.state.CTCPerMonth}
                          onChange={(e) => {
                            if (e.target.value.length > e.target.maxLength) {
                              e.target.value = e.target.value.slice(
                                0,
                                e.target.maxLength
                              );
                            }
                            this.setState({ CTCPerMonth: e.target.value });
                          }}
                        />
                      </div>
                      <div class="pt-4  lg:w-1/2 md:w-1/2  lg:pl-4 md:pl-4">
                        <div className="lg:flex md:flex items-center">
                          <div className=" form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full  lg:pr-3 md:pr-3">
                            <label for="">Currency</label>
                            <div class="relative w-full right-0 rail-select">
                              <div class="select-side">
                                {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                                <ChevronDown className="text053C6D" />
                              </div>
                              <select
                                 required
                                className="select-dropdown-c fsize15"
                                value={this.state.CurrencyID}
                                onChange={(e) =>
                                  this.setState({ CurrencyID: e.target.value })
                                }
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {this.props.CURRENCY
                                  ? this.props.CURRENCY.Data
                                    ? this.props.CURRENCY.Data.map((x) => {
                                        return (
                                          <option value={x.Value}>
                                            {x.SalaryAmount}
                                          </option>
                                        );
                                      })
                                    : ""
                                  : ""}
                              </select>
                            </div>
                          </div>

                          <div className=" form-group modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pt-0 md:pt-0 pt-4 lg:pl-3 md:pl-3">
                            <label for="">Employee Code</label>
                            <input
                              required
                              maxLength={15}
                              type="text"
                              placeholder=""
                              className=" fsize15"
                              value={this.state.EmployeeCode}
                              onChange={(e) =>
                                this.setState({ EmployeeCode: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group pt-4 modal-form-cs  lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-3">
                        <label for="">Employment Type</label>
                        <div class="relative w-full right-0 rail-select">
                          <div class="select-side">
                            {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                            <ChevronDown className="text053C6D" />
                          </div>
                          <select
                            required
                            className="select-dropdown-c fsize15"
                            value={this.state.EmploymentTypeID}
                            onChange={(e) =>
                              this.setState({
                                EmploymentTypeID: e.target.value,
                              })
                            }
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {this.props.EMPTYPE
                              ? this.props.EMPTYPE.Data
                                ? this.props.EMPTYPE.Data.map((x) => {
                                    return (
                                      <option value={x.Value}>{x.Title}</option>
                                    );
                                  })
                                : ""
                              : ""}
                          </select>
                        </div>
                      </div>

                      <div class="pt-4  lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                        <div className="items-center">
                          <div className=" form-group modal-form-cs  w-full ">
                            <label for="">Country</label>
                            <div class="relative w-full right-0 rail-select">
                              <div class="select-side">
                                {/* <i class="glyphicon glyphicon-menu-down blue"></i> */}
                                <ChevronDown className="text053C6D" />
                              </div>
                              <select
                                required
                                className="select-dropdown-c fsize15"
                                value={this.state.CountryID}
                                onChange={(e) =>
                                  this.setState({ CountryID: e.target.value })
                                }
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {this.props.COUNTRYMASTER
                                  ? this.props.COUNTRYMASTER.Data
                                    ? this.props.COUNTRYMASTER.Data.map((x) => {
                                        return (
                                          <option value={x.Value}>
                                            {x.Title}
                                          </option>
                                        );
                                      })
                                    : ""
                                  : ""}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="pt-4 form-group modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pr-4 md:pr-4">
                      <label for="">Office Address</label>
                      <input
                        required
                        // maxLength={60}
                        type="text"
                        placeholder=""
                        className="fsize15"
                        value={this.state.OfficeAddress}
                        onChange={(e) =>
                          this.setState({ OfficeAddress: e.target.value })
                        }
                      />
                    </div>
                    {/* role */}
                    {this.renderformHTML()}
                    {/* end */}
                    {this.state.inputList.length <= 2 && (
                      <p
                        className="textE77817 text-right pt-3 font-semibold fsize14"
                        onClick={this.handleAddClick}
                      >
                        ADD MORE +
                      </p>
                    )}

                    <div class="form-group mt-6 modal-form-cs lg:pr-3 md:pr-3 lg:w-1/2 md:w-1/2 w-full">
                      <label for="">Reason(s) for Leaving *</label>
                      <input
                        required
                        type="text"
                        placeholder=""
                        className="h-80px pb-12 fsize15"
                        value={this.state.ReasonforLeaving}
                        onChange={(e) =>
                          this.setState({ ReasonforLeaving: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="text-right sm-flex mt-16">
                  <button
                    className="outline-button outline-border2px w-200px sm-fsize14 h-50px font-semibold rounded-25px fsize16 mr-4"
                    onClick={() =>
                      this.setState({
                        isAddExperience: !this.state.isAddExperience,
                        ReasonforLeaving: "",
                        OfficeAddress: "",
                        EmploymentTypeID: "",
                        EmployeeCode: "",
                        CurrencyID: "",
                        CTCPerMonth: "",
                        IndustryID: "",
                        Organization: "",
                      })
                    }
                  >
                    CANCEL
                  </button>
                  <button className="filled-button w-200px filled-border2px h-50px sm-fsize14 font-semibold rounded-25px fsize16 ml-4">
                    SAVE
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    EMPLOYEMENTDETAILS: state.userWalkthrough.info.EMPLOYEMENTDETAILS,
    DESIGNATION: state.master.info.DESIGNATION,
    CURRENCY: state.master.info.CURRENCY,
    DEPARTMENT: state.master.info.DEPARTMENT,
    EMPTYPE: state.master.info.EMPTYPE,
    INDUSTRY: state.master.info.INDUSTRY,
    COUNTRYMASTER: state.master.info.COUNTRYMASTER,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEmployeeAction: async (payload) =>
      await dispatch(getEmployeeAction(payload)),
    setEmploymentAction: async (payload) =>
      await dispatch(setEmploymentAction(payload)),
    getDESIGNATIONAction: async (payload) =>
      await dispatch(getDESIGNATIONAction(payload)),
    getCURRENCYAction: async (payload) =>
      await dispatch(getCURRENCYAction(payload)),
    getDEPARTMENTMASTERAction: async (payload) =>
      await dispatch(getDEPARTMENTMASTERAction(payload)),
    getEMPTYPEMASTERAction: async (payload) =>
      await dispatch(getEMPTYPEMASTERAction(payload)),
    getINDUSTRYMASTERAction: async (payload) =>
      await dispatch(getINDUSTRYMASTERAction(payload)),
    getCOUNTRYMASTERAction: async (payload) =>
      await dispatch(getCOUNTRYMASTERAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Experience);
